// ======================================================================
// File Name       : ActionTypes
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const LOGIN = 'LOGIN';
export const LOGINED = 'LOGINED';
export const LOGOUT = 'LOGOUT';
export const RECEIVE_AUTHED_USER = 'RECEIVE_AUTHED_USER';
export const SERVICE_SEARCH = 'SERVICE_SEARCH';
export const SERVICE_LOGIN = 'SERVICE_LOGIN';
export const UPDATE_AUTH_USER_SERVICE = 'UPDATE_AUTH_USER_SERVICE';
export const UPDATE_AUTH_USER_INFO = 'UPDATE_AUTH_USER_INFO';


// User Authority
export const AUTHORITY_RECEIVE_LIST = 'AUTHORITY_RECEIVE_LIST';

// Content
export const CONTENT_VIDEO_SEARCH = 'CONTENT_VIDEO_SEARCH';
export const VIDEO_URL = 'VIDEO_URL';
export const VIDEO_EDIT = 'VIDEO_EDIT';

// Enterprise

// Enterprise
export const ENTERPRISE_STRUCTURE = 'ENTERPRISE_STRUCTURE';
export const ENTERPRISE_EDIT = 'ENTERPRISE_EDIT';
export const ENTERPRISE_IMPORT = 'ENTERPRISE_IMPORT';

// TOP
export const ENTERPRISE_NOTICE_LIST = 'ENTERPRISE_NOTICE_LIST';
export const ENTERPRISE_NOTICE_DETAIL = 'ENTERPRISE_NOTICE_DETAIL';
export const SERVICE_NOTICE_DETAIL = 'SERVICE_NOTICE_DETAIL';

// EDIT LIST
export const EDIT_LIST_RECEIVE_RESULT = 'EDIT_LIST_RECEIVE_RESULT';

export const IMPORT_LIST_RECEIVE_RESULT = 'IMPORT_LIST_RECEIVE_RESULT';

// ContentDistribution
export const CONTENT_DISTRIBUTION_SERVICE_SEARCH = 'CONTENT_DISTRIBUTION_SERVICE_SEARCH';
export const CONTENT_DISTRIBUTION_SERVICE_RECEIVE_ENRTERPRISES = 'CONTENT_DISTRIBUTION_SERVICE_RECEIVE_ENRTERPRISES';
export const CONTENT_DISTRIBUTION_CONTENTS_LIST = 'CONTENT_DISTRIBUTION_CONTENTS_LIST';
export const CONTENT_DISTRIBUTION_CONTENTS_LIST_DELETED = 'CONTENT_DISTRIBUTION_CONTENTS_LIST_DELETED';
export const CONTENT_DISTRIBUTION_CONTENTS_LIST_UPDATED = 'CONTENT_DISTRIBUTION_CONTENTS_LIST_UPDATED';
export const CONTENT_DISTRIBUTION_CONTENT_INIT = 'CONTENT_DISTRIBUTION_CONTENT_INIT';
export const CONTENT_LIST_RECEIVE_SORT = 'CONTENT_LIST_RECEIVE_SORT';
export const CONTENT_DISTRIBUTION_GET_CONTENT_LIST = 'CONTENT_DISTRIBUTION_GET_CONTENT_LIST';
export const CONTENT_DISTRIBUTION_ADD_CONTENT_LIST = 'CONTENT_DISTRIBUTION_ADD_CONTENT_LIST';
export const CONTENT_DISTRIBUTION_EDIT_CONTENT = 'CONTENT_DISTRIBUTION_EDIT_CONTENT';
export const IMPORT_CONTENT_DISTRIBUTION_LIST = 'IMPORT_CONTENT_DISTRIBUTION_LIST';
export const RECEIVED_CONTENT_DISTRIBUTION_FILE_LIST = 'RECEIVED_CONTENT_DISTRIBUTION_FILE_LIST';
export const CONTENT_DISTRIBUTION_USAGE = 'CONTENT_DISTRIBUTION_USAGE';
export const COURSE_DISTRIBUTION_USAGE = 'COURSE_DISTRIBUTION_USAGE';
export const CONTENT_DISTRIBUTION_SERVICE_DELETE_RESULT = 'CONTENT_DISTRIBUTION_SERVICE_DELETE_RESULT';
export const CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL_RESET = 'CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL_RESET';
export const CONTENT_DISTRIBUTION_COURSE_LIST = 'CONTENT_DISTRIBUTION_COURSE_LIST';

// Content Drill List
export const CONTENT_DRILL_LIST_SEARCH = 'CONTENT_DRILL_LIST_SEARCH';
export const CONTENT_DRILL_LIST_DOWNLOAD = 'CONTENT_DRILL_LIST_DOWNLOAD';
export const CONTENT_DRILL_DETAIL = 'CONTENT_DRILL_DETAIL';
export const CONTENT_DELETE_DRILL = 'CONTENT_DELETE_DRILL';
export const CONTENT_DRILL_EDIT = 'CONTENT_DRILL_EDIT';

// Content drill skin
export const CONTENT_DRILL_SKIN_LIST = 'CONTENT_DRILL_SKIN_LIST';
export const CONTENT_DRILL_SKIN_SEARCH_RESULT = 'CONTENT_DRILL_SKIN_SEARCH_RESULT';
export const CONTENT_DRILL_SKIN_INSERT = 'CONTENT_DRILL_SKIN_INSERT';
export const CONTENT_DRILL_SKIN_EDIT = 'CONTENT_DRILL_SKIN_EDIT';
export const CACHE_DRILL_SKIN_LIST = 'CACHE_DRILL_SKIN_LIST';

export const SERVICE_RECEIVE_ENTERPRISE_STRUCTURE = 'SERVICE_RECEIVE_ENTERPRISE_STRUCTURE';


// Live Performance List
export const LIVE_PERFORMANCE_LIST = 'LIVE_PERFORMANCE_LIST';
export const LIVE_PERFORMANCE_LIST_USER_COUNT = 'LIVE_PERFORMANCE_LIST_USER_COUNT';
export const LIVE_PERFORMANCE_DETAIL = 'LIVE_PERFORMANCE_DETAIL';
export const LIVE_PERFORMANCE_DETAIL_PAGING = 'LIVE_PERFORMANCE_DETAIL_PAGING';

export const GET_QUESTION_LIST_DRILL_DETAIL = 'GET_QUESTION_LIST_DRILL_DETAIL';
export const REMOVE_ALL_DISTRIBUTION_COURSE_OR_CONTENT_FROM_LIST = 'REMOVE_ALL_DISTRIBUTION_COURSE_OR_CONTENT_FROM_LIST';
// #7129 START
export const RESET_LIVE_PERFORMANCE_DETAIL = 'RESET_LIVE_PERFORMANCE_DETAIL';
// #7129 END
// #7287 START
export const IMPORT_S3_SIGNED_URL = 'IMPORT_S3_SIGNED_URL';
// #7287 END
export const GET_CURRENT_USAGE_STATUS = 'GET_CURRENT_USAGE_STATUS';

// STEP9.0.0 START
export const CONTENT_DRILL_QUESTION_FOR_SORT = 'CONTENT_DRILL_QUESTION_FOR_SORT';
export const CONTENT_UPDATE_DISPLAY_ORDER_STRUCTURE_LIST = 'CONTENT_UPDATE_DISPLAY_ORDER_STRUCTURE_LIST';
export const CONTENT_SAVE_DISPLAY_ORDER_DRILL_QUESTION = 'CONTENT_SAVE_DISPLAY_ORDER_DRILL_QUESTION';
// STEP9.0.0 END

// Step 10.0.0 START
// サービスグループ設定
export const SERVICE_GROUP_RECEIVE_LIST = 'SERVICE_GROUP_RECEIVE_LIST';
export const SERVICE_GROUP_RECEIVE_EDITING_GROUP = 'SERVICE_GROUP_RECEIVE_EDITING_GROUP';
export const SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SERVICE = 'SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SERVICE';
export const SERVICE_GROUP_RECEIVE_EDITING_SERVICE = 'SERVICE_GROUP_RECEIVE_EDITING_SERVICE';
export const SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SUPERUSER = 'SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SUPERUSER';
export const SERVICE_GROUP_RECEIVE_EDITING_SUPERUSER = 'SERVICE_GROUP_RECEIVE_EDITING_SUPERUSER';
export const SERVICE_GROUP_RECEIVE_SEARCH_CONDITION_SUPERUSER = 'SERVICE_GROUP_RECEIVE_SEARCH_CONDITION_SUPERUSER';
export const SERVICE_GROUP_RESET_DATA = 'SERVICE_GROUP_RESET_DATA';
export const SERVICE_GROUP_RECEIVE_SERVICE_RELATION = 'SERVICE_GROUP_RECEIVE_SERVICE_RELATION';
export const SERVICE_GROUP_RECEIVE_SUPERUSER_RELATION = 'SERVICE_GROUP_RECEIVE_SUPERUSER_RELATION';
export const SERVICE_GROUP_GET_SERVICE_GROUP_NAME = 'SERVICE_GROUP_GET_SERVICE_GROUP_NAME';
export const SERVICE_GROUP_INIT_EDITING = 'SERVICE_GROUP_INIT_EDITING';
// SuperUserサービスロール設定
export const SUPERUSER_SERVICE_ROLE_RECEIVE_LIST = 'SUPERUSER_SERVICE_ROLE_RECEIVE_LIST';

// SuperUser企業ロール設定
export const SUPERUSER_ENTERPRISE_ROLE_RECEIVE_LIST = 'SUPERUSER_ENTERPRISE_ROLE_RECEIVE_LIST';
// Step 10.0.0 END
